// assets/faq-bilingual.js
(function () {
  function boot(root) {
    if (!root) return;

    const langToggle = root.querySelector('.lang-toggle');
    const tocLinks = root.querySelectorAll('.toc a');
    const en = root.querySelector('#lang-en');
    const zh = root.querySelector('#lang-zh');
    const blocks = { en, zh };
    const searchInput = root.querySelector('#faq-search');
    const clearBtn = root.querySelector('.clear-btn');

    const phEN = root.dataset.phEn || 'Search questions (keywords)…';
    const phZH = root.dataset.phZh || '搜索问题（关键词）…';
    const defaultLang = root.dataset.defaultLang || 'en';

    function setLang(lang) {
      Object.values(blocks).forEach(b => b && b.classList.remove('active'));
      blocks[lang]?.classList.add('active');

      langToggle?.querySelectorAll('button').forEach(b => {
        const active = b.dataset.lang === lang;
        b.classList.toggle('active', active);
        if (active) b.setAttribute('aria-selected', 'true'); else b.removeAttribute('aria-selected');
      });

      tocLinks.forEach(a => {
        const id = a.getAttribute('data-anchor');
        a.href = `#${lang}-${id}`;
      });

      if (searchInput) searchInput.placeholder = (lang === 'zh') ? phZH : phEN;

      try { localStorage.setItem('faq_lang', lang); } catch (e) {}

      if (location.hash) {
        const raw = location.hash.slice(1);
        const idNoLang = raw.replace(/^en-|^zh-/, '');
        const next = `${lang}-${idNoLang}`;
        const el = document.getElementById(next);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      applySearchFilter(searchInput?.value || '', lang);
    }

    function getCurrentLang() {
      try {
        if (location.hash && /^#(en|zh)-/.test(location.hash)) {
          return location.hash.slice(1, 3);
        }
        return localStorage.getItem('faq_lang') || defaultLang;
      } catch (e) { return defaultLang; }
    }

    function clearHighlights(scope) {
      scope.querySelectorAll('mark').forEach(m => {
        const t = document.createTextNode(m.textContent);
        m.replaceWith(t);
      });
    }

    function highlightMatches(el, q) {
      if (!q) return;
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      const texts = [];
      while (walker.nextNode()) texts.push(walker.currentNode);
      texts.forEach(node => {
        const val = node.nodeValue; if (!val) return;
        const idx = val.toLowerCase().indexOf(q.toLowerCase());
        if (idx !== -1) {
          const span = document.createElement('span');
          span.appendChild(document.createTextNode(val.slice(0, idx)));
          const mark = document.createElement('mark');
          mark.textContent = val.slice(idx, idx + q.length);
          span.appendChild(mark);
          span.appendChild(document.createTextNode(val.slice(idx + q.length)));
          node.parentNode.replaceChild(span, node);
        }
      });
    }

    function applySearchFilter(query, lang) {
      const scope = blocks[lang];
      if (!scope) return;

      scope.querySelectorAll('details, section.card').forEach(el => el.classList.remove('hidden'));
      scope.querySelectorAll('details').forEach(d => clearHighlights(d));

      const q = (query || '').trim();
      if (!q) return;

      const detailsList = Array.from(scope.querySelectorAll('details'));
      detailsList.forEach(d => {
        const text = (d.querySelector('summary')?.textContent || '') + ' ' + (d.querySelector('.answer')?.textContent || '');
        const has = text.toLowerCase().includes(q.toLowerCase());
        d.classList.toggle('hidden', !has);
        if (has) highlightMatches(d, q);
      });

      scope.querySelectorAll('section.card').forEach(sec => {
        const visible = sec.querySelectorAll('details:not(.hidden)').length > 0;
        sec.classList.toggle('hidden', !visible);
      });
    }

    const initial = getCurrentLang();
    setLang(initial);

    window.addEventListener('hashchange', () => {
      const h = location.hash.replace('#', '');
      const m = /^(en|zh)-/.exec(h);
      const langInHash = m ? m[1] : null;
      if (langInHash) setLang(langInHash);
    });

    langToggle?.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => setLang(btn.dataset.lang));
    });
    searchInput?.addEventListener('input', (e) => applySearchFilter(e.target.value, getCurrentLang()));
    clearBtn?.addEventListener('click', () => {
      if (searchInput) {
        searchInput.value = '';
        applySearchFilter('', getCurrentLang());
        searchInput.focus();
      }
    });

    // ------- Accordion fail-safe（更强兜底版） -------
    const summaries = root.querySelectorAll('details.details-native > summary');
    summaries.forEach(sm => {
      const d = sm.parentNode;
      sm.setAttribute('role', 'button');
      if (!sm.hasAttribute('tabindex')) sm.setAttribute('tabindex', '0');
      sm.setAttribute('aria-expanded', d.open ? 'true' : 'false');

      sm.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault(); e.stopPropagation();
          d.open = !d.open;
          sm.setAttribute('aria-expanded', d.open ? 'true' : 'false');
        }
      });

      sm.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        d.open = !d.open;
        sm.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      }, { capture: true });

      d.addEventListener('toggle', () => {
        sm.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      });
    });

    root.addEventListener('click', (e) => {
      const sm = e.target.closest('summary');
      if (!sm || !root.contains(sm)) return;
      const d = sm.parentNode;
      if (d && d.tagName === 'DETAILS' && d.classList.contains('details-native')) {
        e.preventDefault(); e.stopPropagation();
        d.open = !d.open;
        sm.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      }
    }, { capture: true });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else { fn(); }
  }

  ready(function () {
    document.querySelectorAll('#faq-blocks-bilingual').forEach(boot);
  });
})();
